import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import AdminPanelFormSection from "components/ProjectSpecificComponents/Elements/AdminForm/molecules/AdminPanelFormSection"
import { observer } from "mobx-react"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import DeadlinesForm from "../../molecules/PTKMForms/DeadlinesForm"
import { useInView } from "react-intersection-observer"

interface Props {
	id?: string
}

const DeadlinesFormSection = observer(({ id }: Props) => {
	const { t } = useTranslation()

	const store = useStore()
	const { ref, inView } = useInView()
	useEffect(() => {
		store.setSectionIsInView({ section: "deadlines", inView })
	}, [inView])

	return (
		<div id={id} ref={ref}>
			<AdminPanelFormSection
				buttonsType="none"
				title={t("forms.header.deadlines")}
				// TO DO : TOOL TIP
				tooltipText={t("forms.tooltip.deadlines")}
			>
				<DeadlinesForm />
			</AdminPanelFormSection>
		</div>
	)
})

export default DeadlinesFormSection
